<template>

	<section>
		<!-- <div v-for="(item, index) in FlightList" :key="item.ID" class="product"> -->
		<div class="product">
			<!-- <div class="productA" v-if="item.ID == type"> -->
			<div class="productA">
				<span class="productA_top">
					<p style="font-size: 28px !important;padding:10px 0 10px 0;">{{ currentObj.ScopeName }}</p>
					<p>
						最低价<span style="font-size: 30px !important;padding:10px 0 10px 0;">¥{{ currentObj.AdultPrice }}</span>/人
					</p>
				</span>
				<span class="productA_center">
					<div v-html="currentObj.ScopeContent"></div>
					<!-- <p>套票包含：</p>
          <p>1、南航珠海飞北京大兴往返机票。</p>
          <p>2、包含机场建设税。</p>
          <p>3、赠送中山到珠海的往返大巴车票。</p>
          <p>4、赠送1次珠海南航两舱/金银卡休息区体验。</p>
          <p>5、赠送北京大兴机场到北京的轻轨往返交通。</p>-->
					<div v-if="currentObj.IsPickup == true">
						<span style="color: red;">
							<p class="more" v-on:click="changeShow(show)">[温馨提示](详情请点击查看V)</p>
							<p v-show="show">1、本活动{{ currentObj.MaxMember }}人起订，针对不同航班价格有所变化，指定航线最低¥{{ currentObj.AdultPrice }}/人。</p>
							<p v-show="show">2、购买前请与客服确认余位，以确认为准，价格以出票为准，一经出票，不退不改。</p>
							<p v-show="show">3、赠送配套服务使用事项请留意条款说明，不可兑换其他产品或现金。</p>
							<p v-show="show">4、此活动期为：{{ currentObj.StartDate }} - {{ currentObj.EndDate }}，详情可咨询在线客服。</p>
						</span>
					</div>
					<div v-if="currentObj.IsPickup == false">
						<span style="color: red;">
							<p class="more" v-on:click="changeShow(show)">[温馨提示](详情请点击查看V)</p>
							<p v-show="show">1、本活动{{ currentObj.MaxMember }}人起订，针对不同航班价格有所变化，指定航线最低¥{{ currentObj.AdultPrice }}/人。</p>
							<p v-show="show">2、购买前请与客服确认余位，以确认为准，价格以出票为准，一经出票，不退不改。</p>
							<p v-show="show">3、活动价不包含机场建设税50元/张，手续费50元/张，详情可咨询在线客服。</p>
							<p v-show="show">4、此活动期为：{{ currentObj.StartDate }} - {{ currentObj.EndDate }}，详情可咨询在线客服。</p>
						</span>
					</div>
				</span>
				<span class="productA_bottom">
					<p>客服电话</p>
					<p>18988598961（王小姐）</p>
					<p>18029902098（何小姐）</p>
					<p>18029902235（钱小姐）</p>
					<p>18029902259（刘小姐）</p>
					<p>0760-88880777</p>
					<p>客服时间：08:00 - 18:30</p>
				</span>
			</div>
		</div>

<!-- 		<span class="productA_bottom" v-if="type == 0">
			<p>客服电话</p>
			<p>18988598961（王小姐）</p>
			<p>18029902098（何小姐）</p>
			<p>18029902235（钱小姐）</p>
			<p>18029902259（刘小姐）</p>
			<p>0760-88880777</p>
			<p>客服时间：08:00 - 18:30</p>
		</span> -->
		<div class="infomation" style="display: flex;">
<!-- 			<div v-if="type == 1" class="goCityDiv" style="margin-left: -2%;">
				出发地:
				<input style="width: 62%;" class="goCity" v-on:keyup="inputgoCity" type="text" placeholder="请输入出发地" />
			</div> -->
<!-- 			<div v-if="type == 1" class="arrCityDiv" style="margin-left: -10%;">
				目的地:
				<input style="width: 62%;" class="arrCity" v-on:keyup="inputarrCity" type="text" placeholder="请输入目的地" />
			</div> -->
			<div style="width:45%;display:flex;justify-content:flex-start;margin-left:3%;" @click="chooseGoDete">
				去程：
				<div style="width:70%;border-bottom: 1px solid #333333;">{{ goDete }}</div>
			</div>
			<div style="width: 50%;display: flex;justify-content: flex-start;" @click="chooseBackDete">
				返程：
				<div style="width:62%;border-bottom: 1px solid #333333;">{{ backDete }}</div>
			</div>
			<div style="margin-left: -2%;">
				姓名 :
				<input :value="name" class="name" v-on:keyup="inputname" type="text" placeholder="输入姓名" />
			</div>
			<div style="margin-left: -10%;">
				电话 :
				<input :value="phone" class="phone" v-on:keyup="inputphone" type="text" placeholder="输入联系电话" />
			</div>
			<div style="width: 100%;margin-left: 3%;">
				出行人数 :
				<input style="width:74%;" class="people" v-on:keyup="inputpeople" type="number" placeholder="出行人数" />
			</div>
			<div style="width: 100%;margin-left: 3%;">
				您的备注 :
				<input style="width:74%;" class="remark" v-on:keyup="inputReamrk" type="text" placeholder="输入您的备注信息" />
			</div>
		</div>

		<button class="appointment" v-on:click="appointment()" style="display: block;">预约</button>
	</section>
</template>

<script>
import baseTool from '../utils/baseFunction';
import flightApi from '../request/flightApi';
import addressApi from '../request/addressApi';
import shop from '../request/scopeApi.js';
export default {
	name: 'shopFlightDetail',
	data() {
		return {
			type: '',
			show: false,
			goCity: '',
			arrCity: '',
			name: '',
			phone: '',
			people: '',
			remark: '',

			goDete: '选择去程日期',
			backDete: '选择返程日期',
			today: baseTool.formatterDate(new Date()), //今天
			tomorrow: baseTool.formatterDate(new Date(new Date().getTime() + 24 * 60 * 60 * 1000)), //明天

			FlightList: [],
			currentObj: null
		};
	},
	components: {},
	mounted() {
		document.querySelector('body').setAttribute('style', 'background-color:#EAF3FA;overflow-y: scroll;height: auto;');
	},
	activated() {
		// console.log('type',this.$route.params.type)
		// if (this.$route.params.type) {
		// console.log(this.$route.params)
		this.type = this.$route.params.type;

		console.log('type1',this.type)
		// }

		this.getUserAddress();
    if(this.type != 0){this.getFligtShopList();}

	},
	methods: {
		getUserAddress() {
			// 获取地址列表
			addressApi.getAddressList(this.$store.state.user.OpenId, '').then(sucRes => {
				if (sucRes.success && sucRes.data.length > 0) {
					sucRes.data.forEach(item => {
						if (item.IsDefault == true) {
							this.name = item.Contact;
							this.phone = item.Mobile;
						}
					});
				}
			});
		},
		getFligtShopList() {
			let that = this;
			this.currentObj = null;
			shop.getFlightShopList(1).then(res => {
				if (res.success && res.data.length > 0) {
					res.data.forEach(obj => {
						obj.StartDate = baseTool.formatDateStr(obj.StartDate, 'date');
						obj.EndDate = baseTool.formatDateStr(obj.EndDate, 'date');
						if(obj.ID==this.type){
							that.currentObj = obj;
							console.log('currentObj->',that.currentObj);
						}
					});
					this.FlightList = res.data;

				}
			});
		},
		changeShow(show) {
			this.show = !show;
		},
		inputgoCity(e) {
			this.goCity = e.target.value;
		},
		inputarrCity(e) {
			this.arrCity = e.target.value;
		},
		inputname(e) {
			this.name = e.target.value;
		},
		inputphone(e) {
			this.phone = e.target.value;
		},
		inputpeople(e) {
			this.people = e.target.value;
		},
		inputReamrk(e) {
			this.remark = e.target.value;
		},
		chooseGoDete() {
			let that = this;
			this.$weui.datePicker({
				start: new Date(), // 从今天开始
				end: baseTool.addDate(new Date(), 60),
				onConfirm: result => {
					let tmpDate =
						result[0].value +
						'-' +
						(result[1].value < 10 ? '0' + result[1].value : result[1].value) +
						'-' +
						(result[2].value < 10 ? '0' + result[2].value : result[2].value);
					that.goDete = tmpDate;
				}
			});
		},
		chooseBackDete() {
			let that = this;
			this.$weui.datePicker({
				start: new Date(), // 从今天开始
				end: baseTool.addDate(new Date(), 60),
				onConfirm: result => {
					let tmpDate =
						result[0].value +
						'-' +
						(result[1].value < 10 ? '0' + result[1].value : result[1].value) +
						'-' +
						(result[2].value < 10 ? '0' + result[2].value : result[2].value);
					that.backDete = tmpDate;
				}
			});
		},
		appointment() {
			var that = this;
			let Productname = '';
			if (this.type == 0) {
				Productname = this.goCity + '-' + this.arrCity;
			} else {
				for (let i = 0; i < this.FlightList.length; i++) {
					if (this.FlightList[i].ID == this.type) {
						Productname = this.FlightList[i].ScopeName;
					}
				}
			}
			if (this.type == 0 && (this.goCity == '' || this.arrCity == '')) {
				alert('出发地或目的地未填写');
				return;
			}
			if (this.name == '') {
				alert('姓名不能为空');
				return;
			} else if (this.phone == '') {
				alert('电话号码不能为空');
				return;
			} else if (this.goDete >= this.backDete) {
				alert('去程日期不得大于返程日期或相同');
				return;
			} else if (this.phone.length < 8 || this.phone.length > 11) {
				alert('电话号码长度不正确');
				return;
			} else if (this.type == 1 && this.backdate > '2020-12-31') {
				alert('珠海 - 北京活动返程截止时间为12月31日！');
				return;
			}
			// } else if (this.people < 3 && (type == 0)) {
			//   alert('出行人数必须3人起');
			//   return;
			// }
			if (this.goDete == '选择去程日期') {
				this.goDete = 'null';
			}
			if (this.backDete == '选择返程日期') {
				this.backDete = 'null';
			}
			if (this.people == '') {
				this.people = '0';
			}
			console.log(this.$store.state.user.OpenId, this.name, this.phone, this.people, this.remark, this.goDete, this.backDete, Productname);
			flightApi
				.appointmentFlight(
					this.$store.state.user.OpenId,
					Productname,
					this.name,
					this.phone,
					'出行人数:' + this.people + '人' + '备注:' + this.remark,
					this.goDete,
					this.backDete
				)
				.then(sucRes => {
					if (sucRes.success == true) {
						(that.goDete = '选择去程日期'), (that.backDete = '选择返程日期'), alert(sucRes.message);
					} else {
						alert(sucRes.message);
					}
				});
		}
	}
};
</script>

<style>
p {
	margin: 0;
	margin-left: 5%;
	margin-right: 5%;
	word-wrap: normal;
	white-space: pre-line;
	word-break: break-all;
}

/* common */
.infomation {
	display: flex;
	flex-wrap: wrap;
	justify-content: space-around;
}

.infomation div {
	display: flex;
	line-height: 35px;
	/* margin-left: 2%; */
	/* margin-right: 5%; */
	width: 45%;
}

.infomation input {
	border: none;
	background: none;
	box-shadow: none;
	border-bottom: 1px solid #333333;
	/* width: 75%; */
	width: 70%;
	padding: 0;
	margin: 0 0 0 5px;
}

.goCity,
.arrCity .godate,
.backdate,
.name,
.phone,
.remark {
	font-size: 16px;
}

.appointment {
	width: 94%;
	margin: 10px 3% 0 3%;
	background: #2754bb;
	color: white;
	height: 40px;
	font-size: 18px;
	border: 0;
	border-radius: 10px;
	line-height: 10px;
}

/* productA */
.productA {
	margin: 0;
	padding: 0;
	border-bottom: #585858 1px solid;
	padding-bottom: 5px;
}

.productA_top {
	text-align: center;
	color: #2754bb;
}

.productA_center {
	text-align: left;
	color: #585858;
	width: 80%;
	margin-left: 5%;
	margin-right: 5%;
}

.productA_bottom {
	text-align: center;
	color: #2754bb;
}

.colorprimary {
	width: 100%;
}

.more {
	font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/shopFlightDetail.vue